module.exports = __webpack_public_path__ + "img/configdisable.8b8ea088.svg";